import { Chip, Tooltip } from '@mui/material'
import { Warning as WarningIcon } from '@mui/icons-material'
import { JobOpportunity } from '../../services/api'
import { INACTIVITY_THRESHOLD_DAYS } from '../../state/jobOpportunities'

// MWA-281 — flags an application that has gone quiet. The wording, the
// threshold and the warning chip are carried over from the pre-rework board
// card, which has since been deleted, so the tables are now the only place
// this appears. Callers hide it on terminal tabs (Closed / Archived),
// where nothing is expected to move and the warning would be a false alarm.
export default function InactivityChip({ job }: { job: JobOpportunity }) {
  const days = job.lastActivityDate
    ? Math.floor((Date.now() - new Date(job.lastActivityDate).getTime()) / (1000 * 60 * 60 * 24))
    : 0

  if (days < INACTIVITY_THRESHOLD_DAYS) return null

  return (
    <Tooltip title={`${days} days with no movement on this application.`}>
      <Chip
        icon={<WarningIcon sx={{ fontSize: 12 }} />}
        label={`${days}d inactive`}
        size="small"
        color="warning"
        variant="outlined"
        sx={{ height: 18, fontSize: '0.65rem' }}
      />
    </Tooltip>
  )
}
